<!--The content below is only a placeholder and can be replaced.-->
<div class="top-sidebar d-flex align-items-center">
    <div class="menu-tablet" (click)="showMenuMoblie()">
        <span>
            <img class="logo" src="../../../../../assets/images/menu.png" alt="logo" />
        </span>
    </div>
    <div class="logo simulatenow-logo d-flex align-items-center" [routerLink]="'/dashboard'">
        <span>
            <img class="logo" src="../../../../../assets/images/logo.png" alt="logo" />
        </span>
        <span class="app-name font-bold"> SimulateNow </span>
    </div>
    <div class="header-search notification profiler d-inline-block">
        <!-- <div class="btn-search d-inline-block float-left">
            <div class="p-0 d-inline-block position-relative float-left">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14.5833 15.6252L9.0625 10.1252C8.65972 10.4724 8.18056 10.7432 7.625 10.9377C7.06945 11.1321 6.47917 11.2293 5.85417 11.2293C4.32639 11.2293 3.03125 10.7016 1.96875 9.646C0.90625 8.59044 0.375 7.31266 0.375 5.81266C0.375 4.31266 0.90625 3.03489 1.96875 1.97933C3.03125 0.923774 4.3125 0.395996 5.8125 0.395996C7.3125 0.395996 8.59028 0.923774 9.64583 1.97933C10.7014 3.03489 11.2292 4.31266 11.2292 5.81266C11.2292 6.40989 11.1319 6.98627 10.9375 7.54183C10.7431 8.09739 10.4583 8.61822 10.0833 9.10433L15.625 14.5835L14.5833 15.6252ZM5.83333 9.81266C6.93056 9.81266 7.86458 9.4203 8.63542 8.63558C9.40625 7.85086 9.79167 6.90989 9.79167 5.81266C9.79167 4.71544 9.40625 3.77447 8.63542 2.98975C7.86458 2.20502 6.93056 1.81266 5.83333 1.81266C4.70833 1.81266 3.75694 2.20502 2.97917 2.98975C2.20139 3.77447 1.8125 4.71544 1.8125 5.81266C1.8125 6.90989 2.20139 7.85086 2.97917 8.63558C3.75694 9.4203 4.70833 9.81266 5.83333 9.81266Z"
                        fill="#E5E5E5"
                    />
                </svg>
                <input type="text" class="input-text" placeholder="Search here" />
            </div>
        </div>
        <div class="notification position-relative">
            <span class="dot red"></span>
            <span>
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M4.33789 20.4814V18.6964H6.59539V10.8477C6.59539 9.32516 7.03727 7.97328 7.92102 6.79203C8.80476 5.61078 9.97289 4.86266 11.4254 4.54766V3.81266C11.4254 3.39266 11.5785 3.03828 11.8848 2.74953C12.191 2.46078 12.5629 2.31641 13.0004 2.31641C13.4379 2.31641 13.8098 2.46078 14.116 2.74953C14.4223 3.03828 14.5754 3.39266 14.5754 3.81266V4.54766C16.0279 4.86266 17.2004 5.61078 18.0929 6.79203C18.9854 7.97328 19.4316 9.32516 19.4316 10.8477V18.6964H21.6891V20.4814H4.33789ZM13.0004 23.6577C12.4229 23.6577 11.9198 23.4477 11.491 23.0277C11.0623 22.6077 10.8479 22.1002 10.8479 21.5052H15.1529C15.1529 22.1002 14.9429 22.6077 14.5229 23.0277C14.1029 23.4477 13.5954 23.6577 13.0004 23.6577ZM8.38039 18.6964H17.6466V10.8477C17.6466 9.55266 17.2004 8.45016 16.3079 7.54016C15.4154 6.63016 14.3216 6.17516 13.0266 6.17516C11.7316 6.17516 10.6335 6.63016 9.73226 7.54016C8.83101 8.45016 8.38039 9.55266 8.38039 10.8477V18.6964Z"
                        fill="#17B978"
                    />
                </svg>
            </span>
        </div> -->
        <div
            class="profiler box-container-profiler position-relative"
            #toggleButtonProfiler
            (click)="setActiveProfiler()"
            id="profiler-top-bar"
        >
            <span id="profiler-top-bar-span">
                <img id="profiler-icon" src="../../../../../assets/images/icon-profiler.png" alt="icon profiler" />
            </span>
            <div class="menu-profiler position-absolute" *ngIf="isMenuOpen" #menuProfiler>
                <ul class="p-0 m-0">
                    <li [routerLink]="['/edit-profile']">
                        <a>{{ 'Text_EditProfile' | translate }}</a>
                    </li>
                    <li [routerLink]="['/change-password']">
                        <a>{{ 'Text_ChangePassword' | translate }}</a>
                    </li>
                    <li (click)="onLogOut()">
                        <a>{{ 'Text_Logout' | translate }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
